import Text from '@passkeys/ui/text';

function Version() {
  return (
    <div className="mt-4 flex flex-1 flex-col justify-end">
      <Text
        align="center"
        className="text-black/40 theme-dark:text-neutral-200"
        dataTestId="app-version"
        monospace
        size={12}
      >
        v{__APP_VERSION__}
      </Text>
    </div>
  );
}

export default Version;
